<input class="pin-header keypad-display form-control text-center mb-2" [value]="pinDisplay" maxlength="4"
  autocomplete="off" placeholder="ENTER PIN" readonly />

  <div class="pin-grid">
    @for (key of keys; track key) {
      <div class="pin-button"
        [ngClass]="{'bottom-left': key === '*', 'bottom-right': key === '<'}" (click)="onKeyPressed(key)">
        @if (key !== '<') {
          {{ key }}
        } @else {
          <i class="bi bi-arrow-left-circle-fill"></i>
        }
      </div>
    }
  </div>